import { useTTS } from '../hooks/useTTS';

interface AudioPlayerProps {
  content: string;
  title: string;
  onSentenceChange?: (index: number) => void;
}

export function AudioPlayer({ content, title, onSentenceChange }: AudioPlayerProps) {
  const tts = useTTS(content, {
    title,
    onSentenceChange
  });

  const handleProgressClick = (e: React.MouseEvent<HTMLDivElement>) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const percent = (e.clientX - rect.left) / rect.width;
    const targetSentence = Math.floor(percent * tts.totalSentences);
    tts.seekTo(targetSentence);
  };

  return (
    <div className="audio-player">
      {/* Progress bar */}
      <div className="audio-progress" onClick={handleProgressClick}>
        <div
          className="audio-progress-fill"
          style={{ width: `${tts.progress}%` }}
        />
      </div>

      {/* Controls */}
      <div className="audio-controls">
        <button onClick={tts.skipBackward} title="Skip backward">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12.066 11.2a1 1 0 000 1.6l5.334 4A1 1 0 0019 16V8a1 1 0 00-1.6-.8l-5.333 4zM4.066 11.2a1 1 0 000 1.6l5.334 4A1 1 0 0011 16V8a1 1 0 00-1.6-.8l-5.334 4z"/>
          </svg>
        </button>

        <button className="play-btn" onClick={tts.toggle}>
          {tts.isPlaying ? (
            <svg width="28" height="28" viewBox="0 0 24 24" fill="currentColor">
              <path d="M6 4h4v16H6V4zm8 0h4v16h-4V4z"/>
            </svg>
          ) : (
            <svg width="28" height="28" viewBox="0 0 24 24" fill="currentColor">
              <path d="M8 5v14l11-7z"/>
            </svg>
          )}
        </button>

        <button onClick={tts.skipForward} title="Skip forward">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
            <path d="M11.933 12.8a1 1 0 000-1.6L6.6 7.2A1 1 0 005 8v8a1 1 0 001.6.8l5.333-4zM19.933 12.8a1 1 0 000-1.6l-5.333-4A1 1 0 0013 8v8a1 1 0 001.6.8l5.333-4z"/>
          </svg>
        </button>
      </div>

      {/* Info row */}
      <div className="audio-info">
        <span>
          {tts.currentSentence + 1} / {tts.totalSentences} sentences
        </span>

        <div className="speed-selector">
          <label htmlFor="speed">Speed:</label>
          <select
            id="speed"
            value={tts.rate}
            onChange={(e) => tts.setRate(parseFloat(e.target.value))}
          >
            <option value="0.75">0.75x</option>
            <option value="1">1x</option>
            <option value="1.25">1.25x</option>
            <option value="1.5">1.5x</option>
            <option value="1.75">1.75x</option>
            <option value="2">2x</option>
          </select>
        </div>
      </div>
    </div>
  );
}
